import React, {useEffect, useState} from 'react'
import { useParams,useNavigate } from 'react-router-dom'; // import useLocation
import './TheFoundationCard.css';

const TheTrustCard = (selectedMenu) => {
    const navigate = useNavigate(); // React Router 的导航钩子
    const { selectedOption } = useParams();
    const decodedOption = decodeURIComponent(selectedOption);
    const [selectedContent, setSelectedContent] = useState(decodedOption-"");
    const handleStepNextClick = (value) => {
        setSelectedContent(selectedContent+value);
    };
    const [isVisible, setIsVisible] = useState(false);

    const clickSubMenu = (value) => {
        setSelectedContent(value);
        setActiveOptionIndex(null);
        if(isNaN(value)){
            //value不是数字,则返回true ,则是需要转到其他页面去
            //for eg.   TheTrust-1
            navigate("/"+value.split("-")[0]+"/"+value.split("-")[1]); // 跳转到指定的 URL
        } else{
            //value是数字,则返回false,则只需要当前页面转即可
            //The vision page now no need to redirect to other page
        }
    };
    // 滚动到顶部
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 平滑滚动
        });
    };


    const handleButtonClick = (url) => {
        window.open(url, '_blank');
    };


    // 当前选中的页码
    const [currentPage, setCurrentPage] = useState(1);

    // 当前展开子菜单的选项索引
    const [activeOptionIndex, setActiveOptionIndex] = useState(null);

    // 每个页面对应的内容和子菜单
    const pages = [
        {
            options: [
                { name: "About The Trust Wai 262", subMenu: ["Legal Status of the Trust", "Ko Matou -Nga Rangatahi Succession Planning-Presentand Future Leaders)"],
                    subDiv:["TheTrust-0","TheTrust-1"]
                },
                { name: "The Vision,Mission and Core Values of the Trust", subMenu: ["Vision, Mission, and Core Values"],
                    subDiv:["TheVisionAndMission-0"]
                },
            ]
        },
        {
            options: [
                { name: "The Foundation(Pou) of the Trust ",
                    subMenu: ["He Wakaputanga 1835 ((Declaration of Independence)-Articles 1 to 4", "Te Tiriti o Waitangi","Te Ao Māori Views","Tino Rangatiratanga"],
                    subDiv:[0,1,2,3] },
                { name: "Wai 262 Flora and Fauna Claim",
                    subMenu: [
                        "What is Wai 262",
                        "When did the claim begin? and why?",
                        "Profile of Claimants",
                        "Waitangi Tribunal's recommendations for the Wai 262flora and fauna claim",
                        "New Zealand's Government's Strategic Approach",
                        "Taonga introduced for Protection",
                        "About The Wai 262 Flora and Fauna Claim",
                        "The Wai 262 Report Released by The Waitangi Tribunal",
                        "What Did the Waitangi Tribunal Report Say About theWai 262 Claim?",
                        "The Waitangi Tribunal Reccomendations",
                    ] },
            ]
        },
        {
            options: [
                { name: "Contemporary Wai 262",
                    subMenu: ["The Wai 262 Contemporary Aspects of the Claim Today",
                        "Flora Taonga",
                        "Fauna Taonga",
                        "Flora and Fauna Taonga - Conclusion",
                        "Protection and Management Plan for Wai 262 Flora and FaunaContemporary Taonga",
                    ] },
                { name: "Association of New Zealand Government", subMenu: ["Sub B3-1", "Sub B3-2"] },
            ]
        },
        {
            options: [
                { name: "New Zealand Legislative Acts", subMenu: ["Sub A4-1", "Sub A4-2"] },
                { name: "International Instruments", subMenu: ["International Instruments in Association with the Wai 262-Year 1800 to Year 2024"] },
            ]
        },
        {
            options: [
                { name: "Al and Cyber Security impacts", subMenu: ["Sub A5-1", "Sub A5-2"] },
                { name: "Wai 262 Contemporary - Food Sovereignty", subMenu: ["Sub B5-1", "Sub B5-2"] },
            ]
        },
        {
            options: [
                { name: "Information Library", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "User Registration", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Donation for Support", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "Information Request", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Clothing Merchandise", subMenu: ["Sub 1", "Sub 2"] },
            ]
        },
    ];

    // 处理点击选项事件
    const handleOptionClick = (index) => {
        setActiveOptionIndex(index === activeOptionIndex ? null : index); // 点击相同选项收起子菜单
    };


    // 监听滚动事件
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);
    return (
        <>
        <div className="pou-container">
            <div className="imgTrust-container">
                <h1 className="h1AboutTrust-container">
                    The Foundation
                </h1>
                <br/>
                <div className="textTrust-container">
                    Learn about the organisation`s role within the Wai 262 movement,learn about Te Tiriti O Waitangi and the concepts of He Whakaputanga.
                </div>
            </div>

            <div className="options">
                {pages[currentPage - 1].options.map((option, index) => (
                    <div key={index} className="option-box">
                        <div onClick={() => handleOptionClick(index)}>{option.name}</div>
                        {/* 子菜单 */}
                        {activeOptionIndex === index && (
                            <div className="sub-menu-floating">
                                {option.subMenu.map((sub, subIndex) => (
                                    <div key={subIndex} className="sub-menu-item" onClick={(e) => clickSubMenu(option.subDiv[subIndex])}>
                                        {sub}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {/* 分页点 */}
            <div className="pagination">
                {pages.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${currentPage === index + 1 ? "active" : ""}`}
                        onClick={() => {
                            setCurrentPage(index + 1);
                            setActiveOptionIndex(null); // 切换页面时关闭子菜单
                        }}
                    ></div>
                ))}
            </div>



            <div className="pou-container2" style={{
                display:selectedContent===0?"block":"none"
            }}>
                <h1 className="pou-title">The Pou (Foundation of The Trust)</h1>
                <h2 className="pou-subtitle">
                    He Wakaputanga 1835 ((Declaration of Independence) – Articles 1 to 4
                </h2>

                <div className="pou-content">
                    <div className="pou-text">
                        <p>
                            He Wakaputanga, declared on 28 October 1835 by 34 northern Māori
                            chiefs (Rangatira) and later signed by others, was a formal
                            assertion of Māori sovereignty and independence. Drafted under the
                            guidance of British Resident James Busby, this declaration had key
                            implications for Māori political autonomy and governance:
                        </p>

                        <h3>Sovereignty (Tino Rangatiratanga)</h3>
                        <p>
                            He Wakaputanga, declared on 28 October 1835 by 34 northern Māori
                            chiefs (Rangatira) and later signed by others, was a formal
                            assertion of Māori sovereignty and independence. Drafted under the
                            guidance of British Resident James Busby, this declaration had key
                            implications for Māori political autonomy and governance:
                        </p>

                        <h3>Self-Governance (Mana Motuhake)</h3>
                        <p>
                            He Wakaputanga established a confederation of hapū (tribes) with the
                            power to make laws and manage affairs internally. It represented an
                            early assertion of Māori self-determination and the right to govern
                            according to their customs (tikanga).
                        </p>

                        <h3>International Recognition</h3>
                        <p>
                            The Declaration sought to create a formal relationship with Britain,
                            asking for protection from foreign threats while reaffirming Māori
                            independence. It was intended to deter other nations, such as France,
                            from exerting influence in New Zealand.
                        </p>

                        <h3>Legacy and Contemporary Relevance:</h3>
                        <p>
                            Today, He Wakaputanga is a foundational document for Māori seeking to
                            assert their rights in legal, political, and environmental matters. It
                            is a founding document of Māori sovereignty that remains
                            unextinguished, reinforcing claims for self-determination and
                            governance. The ongoing relevance of the declaration lies in the
                            assertion that Māori authority over land and resources was never ceded.
                        </p>
                    </div>

                    <div className="pou-images">
                        <div className="pou-highlight-img1">
                        </div>
                        <div className="pou-highlight-img2">
                        </div>
                        <div className="pou-highlight-img3">
                        </div>
                    </div>
                </div>
            </div>
            <div className="pou-container3"  style={{
                display:selectedContent===0?"block":"none"
            }}>
                <h1>He Wakaputanga 1835 - Preamble</h1>
                <h2>Preamble Summary</h2>
                <p>
                    In the preamble, the northern Māori chiefs (Ngāpuhi and other iwi) express concern over increasing
                    interactions with foreign nations and settlers, particularly European traders, missionaries, and
                    explorers, who were arriving in greater numbers. The chiefs recognized the need for a formal
                    declaration to assert their sovereignty and authority over their lands, and to manage these
                    interactions in a way that preserved Māori control over their own affairs. The preamble essentially
                    sets the stage for the formal declaration of sovereignty that follows in the main body of He
                    Wakaputanga. It emphasizes the proactive stance of the Māori leaders in asserting their
                    independence, while also acknowledging the need for external recognition and protection in a rapidly
                    changing political landscape. This context is important because it demonstrates that Māori leaders
                    were actively engaging with global politics and were aware of the need to safeguard their tino
                    rangatiratanga (absolute authority) in the face of increasing international pressures.
                </p>
                <h2>The Preamble Acknowledges:</h2>

                <div className="acknowledgements">
                    <div className="section">
                        <h3>Unity of the Chiefs:</h3>
                        <p>
                            The chiefs of the northern tribes had already begun working together, under a sense of
                            common purpose, to protect their lands and sovereignty. This unity would be crucial for
                            defending their rangatiratanga (chiefly authority).
                        </p>
                    </div>
                    <div className="section">
                        <h3>Need for Law and Order:</h3>
                        <p>
                            The chiefs recognized that with the increasing number of foreigners arriving in New Zealand,
                            there was a growing need to establish law and order to manage these relationships and
                            protect Māori interests. The document would provide a framework for creating laws and
                            governance structures among the United Tribes.
                        </p>
                    </div>
                    <div className="section">
                        <h3>Foreign Encroachment:</h3>
                        <p>
                            The preamble implicitly refers to concerns about foreign intervention, particularly from
                            European powers that might seek to undermine Māori authority. By asserting their
                            sovereignty, the chiefs aimed to prevent foreign nations from claiming control over their
                            lands or people.
                        </p>
                    </div>
                    <div className="section">
                        <h3>Appeal to British Support:</h3>
                        <p>
                            He Wakaputanga was an assertion of mana (authority) by Māori over their lands and
                            governance, pre-empting foreign claims of sovereignty. It expressed Māori intentions to
                            engage internationally while maintaining their autonomy. It also influenced the subsequent
                            relationship between Māori and the British, with the Declaration seen as a precursor to Te
                            Tiriti o Waitangi, which further formalized these relationships.
                        </p>
                        <div className="horizontal-line"></div>

                        <p className="footer-note">
                            Wai 262 connects to He Wakaputanga 1835 (the Declaration of Independence) through the assertion
                            of Māori sovereignty (Tino Rangatiratanga) over their natural resources. The claim aligns with
                            the principles of He Wakaputanga, which recognized Māori self-determination and authority over
                            their lands, including flora and fauna.
                        </p>
                        <div className="horizontal-line"></div>
                    </div>
                </div>
            </div>
            <div className="pou-container3"  style={{
                display:selectedContent===1?"block":"none"
            }}>
                <div className="contentTrustLabel">
                    <h4 className="h4">
                        Threaty of Waitangai in Māori
                    </h4>
                    <br/>
                    <div className="trust-div">
                        <div className="trust-divLeft">
                            <h4 className="h4">
                                Te Tiriti o Waitangi
                            </h4>
                            <br/><br/><br/>
                            Ko Wilkitoria te Kwini o ingarani i tana mahara atawal ki nga Rangatira me nga Hapu o Nu Tirani i tana hiahia hoki kiatohungia ki a ratou o ratou rangatiratanga me to ratou wenua, a kia mau tonu hoki te Rongo ki a ratou me te Atanoho holikua wakaaro ia he mea tika kia tukua mai tetahi Rangatira " hei kai wakarite ki nga langata maori o Nu Tirani - kiawakaaetia e nga Rangatira maori te Kawanatanga o te Kuini ki nga wahikatoa o te wenua nei me nga motu * na te mea hokile tokomaha ke nga tangata o tona lwi Kua noho ki tenei wenua, a e haere mai nei.
                            <br/><br/><br/>
                            Na ko te Kuini e hiahia ana kia wakaritea te Kawanatanga kia kaua ai nga kino e puta mai ki te tangata maori ki te Pakeha enono ture kore ana.
                            <br/><br/><br/>
                            Na,kua pai te Kuini kia tukua a hau a Wiremu Hopihona he Kapitana i te Rolara Nawi hei Kawana mo nga wahi katoa o NuTirani e.tukua aianel amua atu ki te kuini, e mea atu ana ia ki noa Rangatira o te wakaminenoa o noa hapu o Nu Tirani meera Ranaatira atu enei ture ka korerotia nei.
                            <br/><br/>
                        </div>
                        <div className="trust-divRight">
                            <div className="divimg3-containerNew">
                            </div>
                            <br/>
                            <h4 className="h4">
                                Most chiefs signed the Maori text of the Treaty. This text was signed at Waitangi on 6 February 1840, andthereafter in the north and at Auckland, The Māori is reproduced as it was written.
                            </h4>
                            <br/>
                        </div>
                    </div>

                    <h4 className="h4">
                        Ko te tuatahi
                    </h4>
                    <br/><br/>
                    Ko nga Rangatira o te wakaminenga me nga Rangatira katoa hoki ki hai i uri ki tawa wakaminenga ka tuku rawa atu ki teKuini o Ingarani ake tonu atu te Kawanatanga katoa o o ratou wenua.
                    <h4 className="h4">
                        Ko te tuarua
                    </h4>
                    <br/><br/>
                    Ko te Kuini o lngarani ka wakarite ka wakaae ki nga Rangatira ki nga hapu - ki nga tangata katoa o Nu Tirani te tinorangatifratanga o o ratou wenua o ratou kainga me o ratou taonga katoa. Otia ko nga Rangatira o te wakaminenga me ngaRangatira katoa atu ka tuku ki te Kuini te hokonga o era wahi wenua e pal ai te tangata nona te wenua - ki te ritenga o te会utu e wakaritea ai e ratou ko te kai hoko e meatia nei e te Kuini hei kai hoko mona.
                    <br/><br/>
                    <h4 className="h4">
                        Ko te tuatoru
                    </h4>
                    <br/><br/>
                    Hei wakaritenga mai hoki tenei mo te wakaaetanga ki te Kawanatanga o te Kuini - ka tiakina e te Kuini o lingarani ngatangata maori katoa u Nu Tirani ka tukua ki a ratou naa tikanga katoa rite tahi ki ana mea ki nga tangata o ingarani.
                    <br/><br/>
                    [signedWy, Hobson Consul & Lieutenant Governor
                    <br/><br/>
                    Na ko matou ko nga Rangatira o te Wakaminenga o nga hapu o Nu Tirani ka huihui nei ki Waitangi ko matou hoki ko ngaRangatira o Nu Tirani ka kite nei i te'ritenga o enei kupu. Ka tangchia ka wakaaetia katoatia e matou, koia ka tohungia ai omateu ingoa o matou tohu.
                    <br/><br/>
                    Ka meatia tenei ki Waitangi i te ono o nga ra o Pepuerii te tau kotahi mano e waru rau e wa te kau o to tatou Arikj.
                    <br/><br/>
                    Ko nga Rangatira o te Wakaminenga
                    <br/><br/>
                    <br/><br/>
                    <h4 className="h4Trust">
                        Relevant Articles for Learning More About The Treaty
                    </h4>

                    <div className="resource-trust-container">
                        <div className="resource-1"></div>
                        <div className="resource-trust-right-container">
                            <h1 className="contentTrustBlack">The Treaty of Waitangi trail</h1>
                            <label>Over 40 rangatira signed the Treaty at Waitangi, among themmany who had signed the Declaration of independence.</label>
                            <br/><br/>
                            <button className="read-more-btn" onClick={() => handleButtonClick('https://www.tepapa.govt.nz/discover-collections/read-watch-play/maori/treaty-waitangi/treaty-close/treaty-waitan-gi-trail')}>Read Article</button>
                        </div>
                    </div>
                    <div className="resource-trust-container">
                        <div className="resource-2"></div>
                        <div className="resource-trust-right-container">
                            <h1 className="contentTrustBlack">The making of the Treaty of Waitangi</h1>
                            <label>Maori Sovereignty was not signed over to Hobson by NgaHapuu Rangatira -please add this as a very important pointand refer to the Maori Wersion.</label>
                            <br/><br/>
                            <button className="read-more-btn" onClick={() => handleButtonClick('https://www.tepapa.govt.nz/discover-collections/read-watch-play/maori/treaty-waitangi/treaty-waitangi-close/mak-ing-treaty')}>Read Article</button>
                        </div>
                    </div>
                    <br/>
                    <div className="resource-trust-container">
                        <div className="resource-3"></div>
                        <div className="resource-trust-right-container">
                            <h1 className="contentTrustBlack">The content of the Treaty of Waitangi</h1>
                            <label>Te Tiriti o waitangi was not signed by the lwi, it was Signedby Nga Hapuu Rangatira</label>
                            <br/><br/>
                            <button className="read-more-btn" onClick={() => handleButtonClick('https://www.tepapa.govt.nz/discover-collections/read-watch-play/maori/treaty-waitangi/treaty-close/content-trea-ty-waitangi')}>Read Article</button>
                        </div>
                    </div>
                    <br/>
                    <div className="resource-trust-container">
                        <div className="resource-4"></div>
                        <div className="resource-trust-right-container">
                            <h1 className="contentTrustBlack">Report on Stage 1 of the Te Paparahi o TeRaki Inquiry Released</h1>
                            <label>Te Paparahi o Te Raki ( The Great Lands of NorthlandWaitangi Tribunal Report - states that "Nga Hapuu Rangatirathat signed Te Tiriti o Waitangi 1840 " "Did not cede theirSovereignty to the British Monarchy.'</label>
                            <br/><br/>
                            <button className="read-more-btn" onClick={() => handleButtonClick('https://waitangitribunal.govt.nz/news/report-on-stage-1-of-the-te-paparahi-o-te-raki-inquiry-released-2/')}>Read Article</button>
                        </div>
                    </div>
                    <br/>
                </div>
            </div>
            <div className="pou-container3"  style={{
                display:selectedContent===2?"block":"none"
            }}>
                <h1>Te Ao Māori Views</h1>

                <p>
                    Te Ao Māori refers to the Māori worldview, which encompasses the cultural, spiritual, and ecological
                    perspectives of Māori society. It is deeply rooted in Māori tikanga (customs), values, and
                    relationships with the natural world.
                </p>

                <h2>Whakapapa (Genealogy) and Connection to the Land</h2>
                <p>
                    Māori view themselves as inseparable from the land, waters, and sky, tracing their genealogy back to
                    the atua (gods) and whenua (land). This connection places an obligation on Māori to act as kaitiaki
                    (guardians) of the environment, protecting and preserving natural resources for future generations.
                </p>

                <h2>Tikanga (Customs and Protocols)</h2>
                <p>
                    Māori customs and laws are a reflection of their values, which prioritize communal well-being,
                    respect for the environment, and reciprocity. Tikanga is living and adaptive, and Māori continue to
                    apply it in various areas, including resource management, dispute resolution, and governance.
                </p>

                <h2>Whanaungatanga (Kinship and Relationships)</h2>
                <p>
                    Relationships are fundamental in Te Ao Māori. Whanaungatanga emphasizes the importance of family and
                    community, extending to the relationship Māori have with the land, natural world, and spiritual
                    realms. This concept informs Māori approaches to decision-making, emphasizing collective benefit and
                    responsibility over individual gain.
                </p>

                <h2>Mana and Tapu (Spiritual Power and Sacredness)</h2>
                <p>
                    Mana refers to the spiritual authority or prestige that individuals and groups hold, while tapu
                    relates to the sacredness inherent in people, places, and objects. Both concepts are integral to Te
                    Ao Māori, guiding behaviour, interactions, and relationships.
                </p>

                <h2>Te Reo Māori (Māori Language)</h2>
                <p>
                    Te Reo is a vital component of Māori identity and culture. Its revitalization is seen as crucial to
                    maintaining Māori customs and knowledge. AI and digital tools are increasingly being used to support
                    the preservation and promotion of Te Reo Māori.
                </p>

                <h2>Contemporary Challenges</h2>
                <p>
                    Māori today face challenges such as the loss of land and resources, environmental degradation,
                    disparities in health, education, and economic outcomes, and the struggle to maintain cultural
                    practices in a modern world. However, there is also a strong resurgence of Māori identity, language,
                    and political activism, with ongoing efforts to reclaim tino rangatiratanga and ensure that the
                    principles of Te Ao Māori are respected in contemporary governance and legal frameworks.
                </p>

                    <p className="footer-note">
                        Te Ao Māori, with its emphasis on collective well-being, environmental stewardship, and
                        spiritual connection, provides a framework through which Māori seek to navigate the modern world
                        while maintaining their identity and values. Both historical documents and the Māori worldview
                        remain vital in discussions about governance, justice, and sovereignty in New Zealand today.
                    </p>
                    <p className="footer-note">
                        Te Ao Māori views, which encompass holistic understandings of the relationship between people,
                        land, and nature, are at the heart of Wai 262. The claim challenges Western frameworks that
                        prioritize economic exploitation of natural resources and instead promotes values like
                        kaitiakitanga (guardianship), manaakitanga (care), and whakapapa (genealogical connections to
                        the natural world).
                    </p>


            </div>
            <div className="pou-container3"  style={{
                display:selectedContent===3?"block":"none"
            }}>
                <h1>Tino Rangatiratanga (Sovereignty and Self-Determination)</h1>
                <p>
                    Tino rangatiratanga is central to Te Ao Māori. It is the inherent right of Māori to govern themselves and their resources, ensuring that their customs and values are upheld. This concept, embedded in both He Wakaputanga and Te Tiriti, drives contemporary Māori movements for autonomy, social justice, and the protection of Māori intellectual property.
                </p>
                <p>
                    Tino Rangatiratanga, or Māori sovereignty, is a fundamental aspect of Wai 262. The claim asserts that Māori have inherent rights to control and protect their indigenous flora and fauna. It seeks to reclaim decision-making power over these resources, aligning with broader aspirations for self-determination.
                </p>

                <h2>Conclusion</h2>
                <p>
                    Each of these sectors reflects the multifaceted impact of the Wai 262 claim, illustrating the depth and breadth of Māori relationships with their natural heritage and the need for a paradigm shift in how New Zealand approaches these issues.
                </p>
            </div>
            <div className="nextAndPre">

                {selectedContent !== 0  && (
                    <label onClick={() => handleStepNextClick(-1)}>Pre </label>
                )}
                <label onClick={() => handleStepNextClick(1)}>
                    {selectedContent === 0  && (
                        <label> Next </label>
                    )}
                    {selectedContent === 1  && (
                        <label> Next </label>
                    )}
                    {selectedContent === 2  && (
                        <label> Next </label>
                    )}
                 </label>
            </div>
            <div
                className="scroll-div"
                onClick={scrollToTop} // 点击事件
                title="Scroll back to top" // 鼠标悬浮提示
            ></div>
        </div>
        </>

  );
}

export default TheTrustCard